import { createAction, props } from '@ngrx/store';

const state = '[UI]';

export const dismissInfoPanel = createAction(
  `${state} Dismiss info panel`,
  props<{ panelId: string }>()
);
